











import { defineComponent } from '@vue/composition-api';
import { ParagraphSize, IconSize, SkeletonType } from '@getaccept/lib-ui';

export default defineComponent({
  name: 'DashboardWidgetListSkeleton',
  props: {
    rows: {
      type: Number,
      default: 6,
    },
    isTopPerformer: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      ParagraphSize,
      IconSize,
      SkeletonType,
    };
  },
});
